import type { DpEvent } from '@/core/events/DpEvent';

export class TaskFeedFetchedEvent implements DpEvent {
  readonly name = 'TaskFeedFetchedEvent';
}
